import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrencyFilter } from '../selectors';

/**
 * Dashboard hook for global/external Power BI filters.
 *
 * These filters are not visual-specific; they come from higher-level UI state.
 * Currently this includes the currency filter.
 *
 * @returns {Array} List of global Power BI filters to apply.
 */
const useGlobalPbiFilters = () => {
  const currencyFilter = useSelector(selectCurrencyFilter);

  return useMemo(() => {
    if (!currencyFilter) {
      return [];
    }

    return [currencyFilter];
  }, [currencyFilter]);
};

export default useGlobalPbiFilters;
